<rotec-modal-v2 title="Session expired" [width]="width" [darkMode]="true">
  <ng-container ngProjectAs="modal-main">
    <div class="error-text">
      {{ 'Your session has expired. Please log in again.' | translate }}
    </div>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <div class="session-modal-buttons">
      <button rotec-button-active (click)="logIn()">
        {{ 'Log In' | translate }}
      </button>
    </div>
  </ng-container>
</rotec-modal-v2>
